import React from 'react'
import { apiUrl } from '@libs/appUrl'
import { getCookie } from '@libs/cookies'

// 送 creator/post PV 讓前台觀看次數和創作者後台的瀏覽數能即時更新
export function useSendArticlePageView(postID: string, hasError?: boolean): void {
  React.useEffect(() => {
    if (hasError || !postID) return
    setTimeout(() => {
      try {
        const data = new FormData()
        data.append('postID', postID)
        // 雖然說看似送 creator pv 應該只會有 /forum 開頭的
        // 但根據之前的邏輯都會送 (https://github.com/popdaily/popdaily.server/blob/v2.2.2/web/views/assets/js/pa.js#L570)
        fetch(apiUrl('/creator/share/pv'), {
          method: 'POST',
          body: data,
        })
      } catch (error) {
        console.warn(error)
      }
    }, 5000)
    try {
      const token = getCookie('user.token')
      const sendPostPageView = (token: string) => {
        const data = new FormData()
        data.append('postID', postID)
        data.append('token', token)
        data.append('platform', window.appPlatform || (window.innerWidth >= 768 ? 'web' : 'mweb'))
        return fetch(apiUrl('/post/view'), {
          method: 'POST',
          body: data,
        })
      }
      const guestPV = () =>
        fetch(apiUrl('/login/guest'))
          .then((response) => response.json())
          .then(({ token }) => sendPostPageView(token))
      const viewPost = async () => {
        if (token) {
          const { code } = await sendPostPageView(token).then((res) => res.json())
          if (code === 52000) {
            // token 有問題
            await guestPV()
          }
        } else {
          // 無痕模式沒 cookie 另外產生
          await guestPV()
        }
      }
      viewPost()
    } catch (error) {
      console.warn(error)
    }
  }, [postID, hasError])
}
